import { Space } from 'antd';
import clsx from 'classnames';
import React, {
  FC,
  useEffect,
  useState,
} from 'react';
import './index.scss';
import TdsLogoDark from './logo-dark.svg';
import TdsLogoLight from './logo-light.svg';
import MenuHomeIcon from './menu-home.svg';
import MenuIcon from './menu.svg';

interface TdsqqNavigationProps {
  className?: string;
  width?: number | string;
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  theme?: 'dark' | 'light';
  scollBgColor?: string;
  activeMenu: TdsqqNavigationMenuItem;
  isProd: boolean;
  isMobile?: boolean;
}

export enum TdsqqNavigationMenuItem {
  Home,
  Bugly,
  Wuji,
  TDF,
  Shiply,
  Rightly,
}

const TDS_QQHOME_URL = 'https://tds.qq.com';
const TEST_TDS_QQHOME_URL = 'https://t.tds.qq.com';

const tdsqqNavigation = [
  {
    title: '首页',
    src: 'https://tds.qq.com',
    key: TdsqqNavigationMenuItem.Home,
  },
  {
    title: '监控定位',
    src: 'https://bugly.tds.qq.com/v2/index/tds-main',
    key: TdsqqNavigationMenuItem.Bugly,
  },
  {
    title: '智能低代码',
    src: 'https://wujicode.cn/xy/app/prod/official/index',
    key: TdsqqNavigationMenuItem.Wuji,
  },
  {
    title: '跨平台框架',
    src: 'https://framework.tds.qq.com/',
    key: TdsqqNavigationMenuItem.TDF,
  },
  {
    title: '全场景发布',
    src: 'https://shiply.tds.qq.com/',
    key: TdsqqNavigationMenuItem.Shiply,
  },
  {
    title: '应用合规',
    src: 'https://rightly.tds.qq.com',
    key: TdsqqNavigationMenuItem.Rightly,
  },
];

const testTdsqqNavigation = [
  {
    title: '首页',
    src: 'https://t.tds.qq.com',
    key: TdsqqNavigationMenuItem.Home,
  },
  {
    title: '监控定位',
    src: 'https://t.bugly.tds.qq.com/v2/index/tds-main',
    key: TdsqqNavigationMenuItem.Bugly,
  },
  {
    title: '智能低代码',
    src: 'https://test1.u.wujicode.cn/page/index',
    key: TdsqqNavigationMenuItem.Wuji,
  },
  {
    title: '跨平台框架',
    src: 'https://t.framework.tds.qq.com/',
    key: TdsqqNavigationMenuItem.TDF,
  },
  {
    title: '全场景发布',
    src: 'https://test.shiply.tds.qq.com/',
    key: TdsqqNavigationMenuItem.Shiply,
  },
  {
    title: '应用合规',
    src: 'https://test.rightly.tds.qq.com',
    key: TdsqqNavigationMenuItem.Rightly,
  },
];

export const TdsqqNavigation: FC<TdsqqNavigationProps> = (props) => {
  const {
    className,
    width = 1200,
    theme = 'light',
    position = 'fixed',
    scollBgColor = '#FFF',
    activeMenu,
    isProd,
    isMobile = false,
  } = props;

  const [scroll, setScroll] = useState(window.scrollY !== 0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY !== 0);

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = !menuOpen ? 'hidden' : '';
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  };

  const handleMaskClick = () => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <div
      className={clsx('tdsqq-navigation', theme, className)}
      style={{
        position,
        backgroundColor: scroll || menuOpen ? scollBgColor : 'transparent',
        boxShadow: (scroll || menuOpen) ? '0px 1px 4px 0px rgba(42, 58, 134, 0.15)' : 'none',
      }}
    >
      <div
        className="tdsqq-navigation-content"
        style={{ width: typeof width === 'string' ? width : `${width}px` }}
      >
        <img
          src={theme === 'light' ? TdsLogoLight : TdsLogoDark}
          alt="TDS logo"
          className="tdsqq-navigation-logo"
          onClick={() => window.open(isProd ? TDS_QQHOME_URL : TEST_TDS_QQHOME_URL, '_self')}
        />
        {!isMobile ? (
          <Space size={30}>
            {(isProd ? tdsqqNavigation : testTdsqqNavigation).map(item => (
              <a
                key={item.key}
                href={item.src}
                className={clsx(
                  'tdsqq-navigation-content-item',
                  item.key === activeMenu ? 'tdsqq-navigation-content-item-active' : '',
                )}
              >
                {item.title}
              </a>
            ))}
          </Space>
        ) : (
          <div className="tdsqq-navigation-menu-btn" onClick={handleMenuClick}>
            <img src={theme === 'light' ? MenuIcon : MenuHomeIcon} alt="menu" />
          </div>
        )}
      </div>

      <div className={clsx('tdsqq-navigation-dropdown', { open: menuOpen })}>
        {(isProd ? tdsqqNavigation : testTdsqqNavigation).map(item => (
          <a
            key={item.key}
            href={item.src}
            className={clsx(
              'tdsqq-navigation-dropdown-item',
              item.key === activeMenu ? 'active' : '',
            )}
            onClick={handleMenuItemClick}
          >
            {item.title}
          </a>
        ))}
      </div>

      <div
        className={clsx('tdsqq-navigation-mask', { open: menuOpen })}
        onClick={handleMaskClick}
      />
    </div>
  );
};
